import React, { useState, useEffect } from "react";
import HomeSection1 from "./HomeSection1";
import HomeSection2 from "./HomeSection2";
import HomeSection3 from "./HomeSection3";
import HomeSection4 from "./HomeSection4";
import Autodukan_logo from "../../assets/images/autoducan_logo.png";
import {
  getHomeScreenImages,
  getFeaturedProductList,
} from "../../services/home";
import "./Home.css";
import { getCategory } from "../../services/category";
import MetaTags from "../../utils/MetaTags";

export default function HomePage() {
  const [category, setCategory] = useState([]);
  const [product2, setProduct2] = useState([]);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "AutoDukan";
  }, []);

  const getImages = async () => {
    try {
      const res = await getHomeScreenImages();
      if (res.code === 200) {
        setImages(res.data || []);
      } else {
        setImages([]);
      }
    } catch (error) {
      console.error("Error fetching home screen images:", error);
      setImages([]);
    }
  };

  const getAllCategory = async () => {
    try {
      const result = await getCategory();
      if (result.code === 200) {
        setCategory(result.data || []);
      } else {
        setCategory([]);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategory([]);
    }
  };

  const getFeaturedProduct = async () => {
    try {
      const result = await getFeaturedProductList();
      if (result.code === 200) {
        setProduct2(result.data || []);
      } else {
        setProduct2([]);
      }
    } catch (error) {
      console.error("Error fetching featured products:", error);
      setProduct2([]);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          getImages(),
          getAllCategory(),
          getFeaturedProduct(),
        ]);
      } catch (error) {
        console.error("Error fetching homepage data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const current_url = window.location.href;

  const tags = [
    { name: "title", content: "Buy Car 🚗 Spare Parts & Accessories Online in India | AutoDukan" },
    { name: "description", content: "AutoDukan offers a wide range of car spare parts and accessories online in India. Shop now for low prices, all car makes & models, and fast shipping across India." },
    { name: "keywords", content: "car spare parts, car service parts india, auto parts, automobile accessories, car accessories, car parts online, India, buy car parts, auto parts online, vehicle accessories, genuine car parts, car parts store, car parts for sale, car repair parts, aftermarket car parts, engine parts, brake parts, car maintenance, auto parts supplier, buy auto parts online, vehicle spare parts, car parts shop India, discount car parts, replacement car parts, car body parts, car parts and accessories, spare parts online India, car spare parts dealer, car spare online india, best car to buy in india, car blogs, spare parts" },
    { property: "og:title", content: "Buy 🚗 Best Car Spare Parts & Accessories Online in India only on AutoDukan" },
    { property: "og:description", content: "Discover AutoDukan's online marketplace for car spare parts and accessories in India. Enjoy low prices and fast shipping on parts for all car makes and models." },
    { property: "og:url", content: `${current_url}` },
    { property: "og:image", content: `${Autodukan_logo}` },
    { property: "og:type", content: "website" },
    { property: "og:site_name", content: "AutoDukan" },
  ];

  useEffect(() => {
    const cleanupMetaTags = MetaTags(tags);
    return cleanupMetaTags;
  }, [tags]);

  return (
    <>
      <HomeSection1 images={images} />
      <HomeSection2 categorys={category} product2={product2} />
      <HomeSection3 />
      <HomeSection4/>
      {/* <Support show_support={true} /> */}
    </>
  );
}
